<template>
  <div class="gap-60"><hr /></div>
  <h1 style="page-break-before: aiways"></h1>
</template>

<script>
export default {};
</script>
